import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`About`}</h2>
    <blockquote>
      <p parentName="blockquote">{`The English language can not fully capture the depth and complexity of my thoughts. So I'm incorporating Emoji into my speech to better express myself. Winky face.`}</p>
    </blockquote>
    <p>{`Hey I am Naman a Final Year Student pursuing Computer Science Engineering. I am a Full Stack Developer currently looking for Full Time Roles in software development. I have almost a year of industry relevant experience making Full Stack Applications and I specialize in making Front End UI/UX designs using Javascript. If you like my profile you reach out to me on my social handles at the bottom of the page.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      